import { render, staticRenderFns } from "./Landingpage.vue?vue&type=template&id=764d5fec&scoped=true&"
import script from "./Landingpage.vue?vue&type=script&lang=js&"
export * from "./Landingpage.vue?vue&type=script&lang=js&"
import style0 from "./Landingpage.vue?vue&type=style&index=0&id=764d5fec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764d5fec",
  null
  
)

export default component.exports